import React from 'react';
import { render } from 'react-dom';
import MainApp from './MainApp';

const rootEl = document.getElementById('app');

render(<MainApp />, rootEl);
